import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

import {
    IBookInviteClaimPreviewResult,
}                               from '../interfaces';

const getBookInviteClaimPreview = async ({
    test,
    ownerUserId,
    assignmentId,
    claimToken,
}: {
    test: boolean,
    ownerUserId: string,
    assignmentId: string,
    claimToken: string,
}): Promise<IBookInviteClaimPreviewResult> => {
    const functions = getFunctions();
    const callable = httpsCallable<
        {
            test: boolean,
            ownerUserId: string,
            assignmentId: string,
            claimToken: string,
        },
        IBookInviteClaimPreviewResult
    >(
        functions,
        'getBookInviteClaimPreview',
    );
    return callable({
        test,
        ownerUserId,
        assignmentId,
        claimToken,
    }).then((result) => result.data as IBookInviteClaimPreviewResult);
};

export default getBookInviteClaimPreview;
